import React, {useState, useEffect} from "react";
import {Link,useParams,useLocation} from 'react-router-dom';
import moment from 'moment';
import { getData } from '../../config/api-connect';
import {  
        Table, Select, DatePicker, Spin, Input, Breadcrumb,
        Button
      } from 'antd';
import { HomeOutlined, BankFilled,SearchOutlined,FilterFilled } from '@ant-design/icons';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import {toProperCase} from '../../utils/stringUtil.js'
import {getDropdownFilter,getSearchFilter} from '../../utils/filterHelper.jsx'

const { Option } = Select;

const TotalCollections = () => {
	const { venue_name } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let venue_id = queryParams.get('venue_id');
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  var local_city = JSON.parse(localStorage.getItem('cityId'))

  let local_selectedVenueId = venue_id;
  if(!venue_id) {
    local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  }

  const [loading, setLoading] = useState(true)
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [collectionData,setCollectionData] = useState([])

  useEffect(() => {
  	localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    if(cityId !== ''){
      setLoading(true)
      getTotalCollections()
    }
  }, [month,year]); 

  const getTotalCollections = () => {
  	setLoading(true)
    getData(`/business/get_total_collections/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
       setCollectionData(response.results);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };  

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap: 'nowrap' }}>{title}</div>
    )
  }  

  const renderCollectionCustomer = (data,isAmount) => {
    return(
      <div>
        <div>{isAmount ? formatIndianCurrency(data) : data}</div>
      </div>
    )
  }

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const getAmountSorter = (dataIndex) => ({
    sorter: (a, b) => a[dataIndex] - b[dataIndex],
  });

  const sampleData = collectionData[0] || {};

	const columns = [
    ...Object.keys(sampleData).filter(a => a != 'id').map((key) => ({
  	  title: renderHeader(toProperCase(key)),
  	  dataIndex: key,
  	  render: (value, record) => {
  	    const isAmount = key.toLowerCase().includes('amount');
  	    return renderCollectionCustomer(value, isAmount);
  	  },
  	  align: 'center',
      ...((key === 'customer__name' || key === 'Mobile') ? getSearchFilter(key, key) : {}),
      ...((key === 'Venue' || key === 'City' || key === 'Status' || key === 'CollectedBy'
        || key === 'payment__mode'|| key === 'Verified' || key === 'VerifiedBy') ? getDropdownFilter(key,collectionData) : {}),
      ...(key.includes('Date') ? getDateSorter(key) : {}),
      ...((key === 'Amount') ? getAmountSorter(key) : {})
  	  // width: 110,
  	})),
  ];

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/collection">
                <BankFilled />
                <span style={{paddingLeft:'5px'}}>Collection</span>
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
            	<span>Collection List</span>
            </Breadcrumb.Item>

          </Breadcrumb>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <div className = 'mainSelector'>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div> 
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.NewHeader>   
          <span></span>     
          <span>Collection List</span>
          {
             <>
              <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="table-for-download"
                filename={'Total Collections '+ ' ' + moment(month, 'MM').format('MMMM') + ' ' + year}
                sheet={'Total Collections'}
                buttonText="Download"/>
             </>
          }
        </Styled.NewHeader>
        <div className="recordCount">{collectionData?.length || 0} records</div>
        <div>
        	<Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={collectionData}
            pagination={{pageSize: 50, showSizeChanger: false}}
            scroll={{ x: 'max-content' }}
          />
        </div>
			</Styled.MainContainer>
      <table style={{display: 'none'}} id="table-for-download">
        <thead>
          <tr>
            {Object.keys(sampleData).map((head, index) => (
              <th key={index}>{toProperCase(head)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {collectionData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(sampleData).map((key, colIndex) => {
                const value = row[key];
                const isAmount = key.toLowerCase().includes('amount');
                return (
                  <td key={colIndex}>
                    {isAmount ? formatIndianCurrency(value) : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
		</Spin>
	)
}

export default TotalCollections;	